import Bubble from "@/components/header/BubbleAbstrak.vue";
export default {
  name: "MainPage",
  components: {
    Bubble,
  },
  data() {
    return {
      // Menu Items
      menus: [
        {
          label: "Ambil<br>Antrean",
          image: new URL("../assets/img/01.webp", import.meta.url).href,
          route: "/ambil-antrean",
          action: null,
        },
        {
          label: "Tele<br>Konsultasi",
          image: new URL("../assets/img/05.webp", import.meta.url).href,
          route: "/telekonsultasi",
          action: null,
        },
        {
          label: "Konsultasi<br>Psikolog",
          image: new URL("../assets/img/09.png", import.meta.url).href,
          route: "/konsultasi-psikolog",
          action: null,
        },
        {
          label: "Antrean<br>Saya",
          image: new URL("../assets/img/03.webp", import.meta.url).href,
          route: null,
          action: "lihatAntrean",
        },
        {
          label: "Jenis<br>Pelayanan",
          image: new URL("../assets/img/04.webp", import.meta.url).href,
          route: "/jenis-pelayanan",
          action: null,
        },
        {
          label: "Tarif<br>Layanan",
          image: new URL("../assets/img/07.png", import.meta.url).href,
          route: "/tarif-layanan",
          action: null,
        },
        {
          label: "Waktu<br>Layanan",
          image: new URL("../assets/img/06.png", import.meta.url).href,
          route: "/waktu-layanan",
          action: null,
        },
        {
          label: "Pengaduan<br>Layanan",
          image: new URL("../assets/img/08.png", import.meta.url).href,
          route: "/pengaduan-layanan",
          action: null,
        },
        {
          label: "Layanan<br>Lainnya",
          image: new URL("../assets/img/10.png", import.meta.url).href,
          route: "/menu-lainnya",
          action: null,
        },
      ],
    };
  },
  methods: {
    handleMenuClick(menu) {
      if (menu.action === "lihatAntrean") {
        this.lihatAntrean();
      } else if (menu.route) {
        if (/^https?:\/\//i.test(menu.route)) {
          window.open(menu.route, "_blank", "noopener,noreferrer");
        } else {
          this.$router.push(menu.route);
        }
      }
    },
    lihatAntrean() {
      const dataNabelo = localStorage.getItem("dataNabelo");
      if (dataNabelo) {
        this.$router.push("/informasi-antrean");
      } else {
        this.$router.push("/lihat-antrean");
      }
    },
    openManual() {
      this.$router.push("/manual");
    },
  },
};
